import { atom } from "recoil";

export const globalEditState = atom<boolean>({
  key: "globalEditState",
  default: false,
});
